/**
 * Custom hook to manage modal content logic
 */

import { useState, useEffect } from 'react';
import { useCurrentUser2, useSignOut } from 'containers/User';
import { useRequest, request2 } from 'utils/request';

export function useModalContent() {
  const [user, update] = useCurrentUser2();
  const [userData] = useRequest({ url: user.api && '/user/data', user });
  const [pendingEmail, setPendingEmail] = useState(null);
  const [isMerge, setIsMerge] = useState(false);
  const [emailChangeSuccess, setEmailChangeSuccess] = useState(false);
  const signOut = useSignOut();

  const showSupporterPrompt = user.api && !user.pm;

  // Check if there's a pending email change from userData
  useEffect(
    () => {
      if (userData?.value?.pendingEmail) {
        setPendingEmail(userData.value.pendingEmail);
      }
    },
    [userData],
  );

  const handleCancelSubscription = () => {
    request2({
      method: 'DELETE',
      url: `/user/subscribe`,
      user,
    }).then(() => {
      update(['api', 'ar'], 0);
    });
  };

  const handleEmailChangeRequest = (newEmail, mergeAccounts = false) => {
    setPendingEmail(newEmail);
    setIsMerge(mergeAccounts);
    setEmailChangeSuccess(false);
  };

  const handleEmailChangeConfirm = () => {
    const wasMerge = isMerge;
    setPendingEmail(null);
    setIsMerge(false);

    if (wasMerge) {
      // For account merge, sign out the user
      signOut();
    } else {
      // For regular email change, show success and update email
      setEmailChangeSuccess(true);
      update(['email'], pendingEmail);
    }
  };

  const handleEmailChangeCancel = () => {
    setPendingEmail(null);
    setIsMerge(false);
  };

  const dismissEmailSuccess = () => {
    setEmailChangeSuccess(false);
  };

  return {
    user,
    userData,
    pendingEmail,
    isMerge,
    emailChangeSuccess,
    showSupporterPrompt,
    handleCancelSubscription,
    handleEmailChangeRequest,
    handleEmailChangeConfirm,
    handleEmailChangeCancel,
    dismissEmailSuccess,
  };
}
